import { Link, useParams } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import {
  ApplicationTab,
  RouteSource,
} from '@monorepo/shared/src/graph/schema-generated-types-educator';
import TabHeading from 'components/common/TabHeading';
import { AppRoutes } from 'types';

const t = (key: string, options?) => translate('letterTeaching', key, options);

type Props = {
  isSelected?: boolean;
  label?: string;
  route?: string;
  telemetryName?: ApplicationTab;
  handleOnClick?: (telemetryName: ApplicationTab | undefined) => void;
};

const TabHeader = ({ isSelected, label, route, telemetryName, handleOnClick }: Props) => {
  const params = useParams();
  const classes = useStyles({ isSelected });
  const onClick = () => {
    handleOnClick && handleOnClick(telemetryName);
  };
  return (
    <Link
      to={`/letter-teaching/${params.letter}/${route}`}
      state={{ from: RouteSource.DASHBOARD }}
      className={classes.link}
      onClick={onClick}
    >
      <h2 className={classes.h2}>{label}</h2>
    </Link>
  );
};

const TabList = () => [
  {
    Component: ({ isSelected, handleOnClick }) => (
      <TabHeading>
        <TabHeader
          handleOnClick={handleOnClick}
          isSelected={isSelected}
          label={t('letterBook')}
          route={AppRoutes.LETTER_BOOK}
          telemetryName={ApplicationTab.LETTER_BOOK}
        />
      </TabHeading>
    ),
  },
  {
    Component: ({ isSelected, handleOnClick }) => (
      <TabHeading>
        <TabHeader
          handleOnClick={handleOnClick}
          isSelected={isSelected}
          label={t('practiceBook')}
          route={AppRoutes.PRACTICE_BOOK}
          telemetryName={ApplicationTab.PRACTICE_BOOK}
        />
      </TabHeading>
    ),
  },
  {
    Component: ({ isSelected, handleOnClick }) => (
      <TabHeading>
        <TabHeader
          handleOnClick={handleOnClick}
          isSelected={isSelected}
          label={t('teachersGuide')}
          route={AppRoutes.TEACHERS_GUIDE}
          telemetryName={ApplicationTab.TEACHERS_GUIDE}
        />
      </TabHeading>
    ),
  },
  {
    Component: ({ isSelected, handleOnClick }) => (
      <TabHeading>
        <TabHeader
          handleOnClick={handleOnClick}
          isSelected={isSelected}
          label={t('resources')}
          route={AppRoutes.RESOURCES}
          telemetryName={ApplicationTab.RESOURCES}
        />
      </TabHeading>
    ),
  },
];

const useStyles = makeStyles((theme: any) => ({
  h2: {
    color: ({ isSelected }: Props) =>
      isSelected ? theme.palette.black.main : theme.palette.grey[400],
    margin: '0px',
  },
  link: { width: '100%' },
}));

export default TabList;
